import React from 'react'

const Logo = () => {
  const logo = "/icons/logo-bonusbay.svg"


  return (
    <a href='/' className='no-underline'>
      <img className='logo' src={logo} alt="Logo" />
    </a>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js